
import type { PropType } from 'vue'
import { defineComponent, reactive } from 'vue'

export default defineComponent({
    props: {
        sectors: {
            type: Array as PropType<Array<{ id: number; sectorName: string; }>>,
            default: () => []
        }
    },
})
